const HEXADECIMAL_BASE = 16

const ROW_CONTENT_TYPE = 'row'

// Code was taken form https://developer.mozilla.org/en-US/docs/Web/API/SubtleCrypto/digest#Examples
/* istanbul ignore next */
export const hashEmail = async (email: string) => {
  const msgUint8 = new TextEncoder().encode(email)
  const hashBuffer = await crypto.subtle.digest('SHA-1', msgUint8)
  const hashArray = Array.from(new Uint8Array(hashBuffer))
  const hashedEmail = hashArray.map((b) => b.toString(HEXADECIMAL_BASE).padStart(2, '0')).join('')
  return hashedEmail
}

export const isRow = (entry) => entry !== undefined && entry.sys.contentType.sys.id === ROW_CONTENT_TYPE
